import { render, staticRenderFns } from "./KnTextRow.vue?vue&type=template&id=c30b1d8e"
import script from "./KnTextRow.vue?vue&type=script&lang=js"
export * from "./KnTextRow.vue?vue&type=script&lang=js"
import style0 from "./KnTextRow.vue?vue&type=style&index=0&id=c30b1d8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports